import './MainNav.scss';
import Component from './MainNav.js';
export default Component;